<template>
	<div class="registro-finalizado">
		<div class="registro-finalizado-container">
			<div class="registro-finalizado-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="registro-finalizado-form">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<div class="registro-finalizado-section" v-if="verificado">
						<div class="registro-finalizado-title">
							<h1>¡Registro exitoso!</h1>
							<img src="../../assets/check.svg" alt="Verificación exitosa">
						</div>
						<p>Tu registro ha sido completado de manera satisfactoria.</p>
						<router-link class="btn" :to="{name: 'login' }">Entrar</router-link>
					</div>
					<div class="registro-finalizado-section" v-else>
						<div class="registro-finalizado-title">
							<h1>¡Registro fallido!</h1>
							<img src="../../assets/error.svg" alt="Verificación fallida">
						</div>
						<p>Hubo un error y tu registro no ha podido completarse, quizás este link haya expirado. Prueba realizando otro envío de verificación.</p>
						<!-- <a href="#" class="btn">Enviar correo otra vez</a> -->
						<router-link :to="{name: 'home' }">Inicio</router-link>
					</div>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'registro-finalizado',
		data() {
			return {
				verificado: false,
				hashVerificacion: this.$route.params.hashVerificacion
			}
		},
		components: {
			'auth-right': AuthRight
		},
		beforeCreate(){
			if(this.$store.getters.loggedIn === true){
				this.$router.push({ name: 'home' })
			}
		},
		mounted(){
			// Redirijo a Nacional.uy
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;
			
			// if(this.hashVerificacion.length === 36) {
			// 	// Consumo ws con el código de activación
			// 	axios.post('/WSActivacion', {
			// 		ActivacionGUID: this.hashVerificacion
			// 	})
			// 	.then(response => {
			// 		var errorCod = response.data.ErrorCod;
			// 		if (errorCod === 0){
			// 			this.verificado = true;
			// 		} else {
			// 			this.verificado = false;
			// 		}
			// 	}).catch(error => {
			// 		this.verificado = false;
			// 		reject(error)
			// 	})
			// 	this.verificado = true;
			// } else {
			// 	this.verificado = false;
			// }
		}
	}
</script>

<style scoped lang="scss">
	@import '../../styles/typography.scss';
	@import '../../styles/mixins.scss';

	.registro-finalizado{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.registro-finalizado-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.registro-finalizado-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.registro-finalizado-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 450px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						color: #29355c;
						font-size: 14px;
					}

					.registro-finalizado-section{
						position: relative;
						margin: 0;
						@include flex(column, center, flex-start);

						.registro-finalizado-title{
							margin-bottom: 10px;
							@include flex(row, flex-start, center);
							
							img{
								margin-left: 15px;
								margin-top: 12px;
								width: 32px;
								height: auto;
							}
						}

						a.btn{
							margin: 0;
							margin-top: 8px;
							padding: 12px 18px;
							background-color: #11244d;
							color: #fff;
							font-weight: 400;
							font-size: 12px;
							text-transform: uppercase;
							letter-spacing: 2px;
							outline: none;
							border: none;
							border-radius: 5px;
							cursor: pointer;
							transition: all .2s;

							&:hover{
								background-color: #c61431;
								text-decoration: none;
							}

							&:disabled{
								color: rgba(27, 46, 75, 0.9);
								background-color: #ddd;
								cursor: not-allowed;
							}
						}
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1360px){
		.registro-finalizado{
			.registro-finalizado-container{
				.registro-finalizado-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.registro-finalizado{
			.registro-finalizado-container{
				.registro-finalizado-left{
					width: 600px;
					
					.registro-finalizado-form{
						max-width: 380px;
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.registro-finalizado{
			.registro-finalizado-container{
				.registro-finalizado-left{
					width: 100%;
					
					.registro-finalizado-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}
</style>